// extracted by mini-css-extract-plugin
export default {"cls1":"SuggestionCard-cls1__a5b4a952aeffa2031da3","cls2":"SuggestionCard-cls2___5af608b8217928ad24d SuggestionCard-cls1__a5b4a952aeffa2031da3"};